import { useApiClient } from '@/api/client'
import { CheckInClientSchema } from '../types.ts'

export const GET_NEXT_CLIENT_FROM_LIST = '/core/v2/business_api/me/businesses/{businessId}/turntracker/list/next_client'

export const getNextClientFromList = (options: {
  businessId: number;
}) => {
  const apiClient = useApiClient()

  return apiClient.get({
    url: GET_NEXT_CLIENT_FROM_LIST,
    urlParams: {
      businessId: options.businessId,
    },
  })
    .then(({ data }) => CheckInClientSchema.parse(data))
}
